import * as React from "react";
import { useContext } from "react";
import { Container } from "react-bootstrap";
import { RootStoreContext } from "../../../stores/RootStore";
import { Event } from "../../../config/Registration";
import ConfirmButton from "./ConfirmButton";
import EventSelection from "./EventSelection";
import EventTicketsSection from "./EventTicketsSection";
import SellingItemOption from "./SellingItemOption";
import ClassesScheduleEvent from "./ClassesScheduleEvent";
import { eventDateKey, eventTimeMinutes } from "./classesSchedule";

interface ItemsSectionProps {
  showConfirmButtonOnTop: boolean;
  isEventsCategory: boolean;
  selectedEvent: Event | undefined;
  events: Event[];
  onEventSelect: (event: Event) => void;
  isNotEventsCategory: boolean;
  filteredSellingItems: any[];
  showConfirmButtonOnBottom: boolean;
  activeCategory: number;
  isClassesCategory?: boolean;
  classScheduleEvents?: Event[];
  selectedDate?: Date;
  onClassEventSelect?: (event: Event) => void;
}

const itemSortTime = (item: any): number => item.time
  ? item.time.hour * 60 + item.time.minute
  : Number.MAX_SAFE_INTEGER;

const eventSortTime = (event: Event, selectedDate?: Date): number => {
  const selectedKey = selectedDate
    ? `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`
    : '';
  const program = event.programTimes?.find(value => eventDateKey(value.startTime) === selectedKey);
  const value = program?.startTime || event.startTime;
  return eventTimeMinutes(value);
};

const ItemsSection: React.FC<ItemsSectionProps> = ({
  showConfirmButtonOnTop,
  isEventsCategory,
  selectedEvent,
  events,
  onEventSelect,
  isNotEventsCategory,
  filteredSellingItems,
  showConfirmButtonOnBottom,
  activeCategory,
  isClassesCategory = false,
  classScheduleEvents = [],
  selectedDate,
  onClassEventSelect
}) => {
  const { registrationStore } = useContext(RootStoreContext);
  const { formatEventDate } = registrationStore;
  
  return (
    <Container>
      {showConfirmButtonOnTop && (
        <>
          <ConfirmButton />
          <br />
        </>
      )}
      {isEventsCategory && !selectedEvent && events.length > 0 && (
        <EventSelection
          events={events}
          onEventSelect={onEventSelect}
        />
      )}
      {isEventsCategory && selectedEvent && selectedEvent.tickets.length > 0 && (
        <EventTicketsSection
          event={selectedEvent}
          tickets={selectedEvent.tickets}
          formatEventDate={formatEventDate}
        />
      )}
      {isClassesCategory
        ? [
            ...filteredSellingItems.map(item => ({ kind: 'class' as const, item, time: itemSortTime(item) })),
            ...classScheduleEvents.map(event => ({ kind: 'event' as const, event, time: eventSortTime(event, selectedDate) }))
          ].sort((a, b) => a.time - b.time).map((entry, index) => entry.kind === 'class' ? (
            <SellingItemOption
              key={`category-${activeCategory}-class-${entry.item.sellingItemId || index}`}
              item={entry.item}
            />
          ) : (
            <ClassesScheduleEvent
              key={`category-${activeCategory}-event-${entry.event.eventId}`}
              event={entry.event}
              selectedDate={selectedDate!}
              onSelect={onClassEventSelect!}
            />
          ))
        : isNotEventsCategory && filteredSellingItems.map((item, index) => (
            <SellingItemOption
              key={`category-${activeCategory}-item-${index}`}
              item={item}
            />
          ))}
      <br />
      {showConfirmButtonOnBottom && <ConfirmButton />}
      <br />
      <br />
    </Container>
  );
};

export default ItemsSection;
